import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';
import _ from 'underscore';

type Message = {
  message: string;
  color: MessageColor;
};

export enum MessageColor {
  RED = 'red',
  GREEN = 'green',
}

type Subscriber = (message: string, color: MessageColor) => void;

let subscriptions: Subscriber[] = [];
function subscribe(callback: Subscriber) {
  subscriptions.push(callback);
  //console.log('[StatusBar] Component subscribed.');
}

function unsubscribe(callback: Subscriber) {
  subscriptions = _.without(subscriptions, callback);
  //console.log('[StatusBar] Component unsubscribed.');
}

function sendErrorMessage(message: string) {
  toast.error(message);
}

const StatusBar = () => {
  const [messages, setMessages] = useState<Message[]>([]);

  const push = useCallback((message, color) => {
    setMessages((prev) => [...prev, { message, color }]);
  }, []);

  useEffect(() => {
    subscribe(push);
    return () => {
      unsubscribe(push);
    };
  }, [push]);

  const dismissLastMessage = () => {
    setMessages((prev) => prev.slice(0, -1));
  };

  const dismissAllMessages = () => {
    setMessages([]);
  };

  const lastMessage: Message | undefined = messages[messages.length - 1];
  const statusBarClass =
    messages && messages.length > 0 ? 'status-bar open' : 'status-bar';

  return (
    <div className={statusBarClass + ' ' + lastMessage?.color}>
      <p>{lastMessage?.message}</p>
      {messages.length > 1 && (
        <a onClick={dismissAllMessages} className="actionLink button">
          Dismiss all messages ({messages.length})
          <span className="icon-remove"></span>
        </a>
      )}
      <a onClick={dismissLastMessage} className="actionLink button">
        Dismiss <span className="icon-remove"></span>
      </a>
    </div>
  );
};

export default { Component: StatusBar, sendErrorMessage: sendErrorMessage };
